/**
 * Converts string values to arrays by parsing them as JSON. If the JSON parse
 * fails, or doesn't result in an array, an empty array is returned. Any other
 * passed in value that is not an array will coerce to an empty array.
 */
export function coerceToArray(el: HTMLElement, prop: string, val: any): any[] {
  if (typeof val === 'string') {
    try {
      val = JSON.parse(val);
    } catch (e) {
      console.error(
        `${el.tagName} property "${prop}" expects valid JSON if passed a string`,
        e
      );
      return [];
    }
  }

  if (!Array.isArray(val)) {
    console.error(
      `${
        el.tagName
      } property "${prop}" expected an array but got type "${typeof val}"`
    );
    return [];
  }

  return val;
}

/**
 * Convert any value to a boolean. The string literal "false" converts to
 * `false`. All other string values coerce to `true`. For other types, use the
 * truthiness of the value.
 * @param val Any value to coerce.
 * @return A boolean value.
 */
export function coerceToBoolean(val: any): boolean {
  if (val === 'false') {
    return false;
  }

  if (val === '') {
    return true;
  }

  return Boolean(val);
}

/**
 * A converter object that can be used to reflect booleans in a lit-element
 * component. Use as the value of the `converter` field of a property.
 */
export const booleanConverter = {
  fromAttribute(val) {
    return coerceToBoolean(val);
  },
  toAttribute(val) {
    val = coerceToBoolean(val);
    if (!val) {
      return null;
    }
    return '';
  },
};
